import { customColors, customColorsRaw } from '@apollo/orbit';
import { useMemo } from 'react';

import {
  StackConfig,
  useStackInfo,
} from 'src/components/charts/helpers/useStackInfo';

export interface FieldHistogramStackConfig<Data>
  extends StackConfig<Data, { sparseBuckets: number[] }> {
  primaryColor: string;
  cursor: string;
  marker: string;
  hasData: (data: Data) => boolean;
}

export interface FieldHistogramData {
  metrics: {
    fieldHistogram: {
      sparseBuckets: number[];
    };
  };
}

export const useFieldHistogramStackInfo = (
  data: FieldHistogramData[] | undefined,
) => {
  const stacks = useMemo(
    (): FieldHistogramStackConfig<FieldHistogramData>[] => [
      {
        data: data ?? [],
        primaryColor: `rgb(${customColorsRaw.flowchart.d} / 0.6)`,
        cursor: customColors.flowchart.d,
        marker: `rgb(${customColorsRaw.flowchart.c} / 0.6)`,
        label: 'Requests',
        hasData: ({ metrics }) =>
          metrics.fieldHistogram.sparseBuckets.some((v) => v > 0),
        getValue: ({ metrics }) => metrics.fieldHistogram,
      },
    ],
    [data],
  );
  return useStackInfo<
    FieldHistogramData,
    { sparseBuckets: number[] },
    FieldHistogramStackConfig<FieldHistogramData>
  >(stacks);
};
